<script lang="ts">
	import type { Achievement } from '../../../domain/Achievement';
	import AchievementBaseCard from '$components/home/achievement/AchievementBaseCard.svelte';
	import AchievementProgress from '$components/home/achievement/elements/AchievementProgress.svelte';
	import AchievementBody from '$components/home/achievement/elements/AchievementBody.svelte';
	import { comingSoonSheet } from '$components/home/SheetData';
	import AchievementFooter from '$components/home/achievement/elements/AchievementFooter.svelte';
	import { formatPreviousDayWithDayAndMonth, formatSameDayWithDayAndMonth } from '$services/DateFormatter';

	export let achievement: Achievement;
	export let index: number;
	export let onclick: Function;
	export let isHorizontal: boolean = false;
	export let display: 'row' | 'grid';
	export let onViewPortCallback: Function | undefined = undefined;

	const startDate = achievement.content.progressStartDate ? formatSameDayWithDayAndMonth(achievement.content.progressStartDate) : '';
	const endDate = formatPreviousDayWithDayAndMonth(achievement.content.progressEndDate!);
</script>

<AchievementBaseCard achievement={achievement} display={display} index={index+1} {onViewPortCallback}>
	<oc-card-v2
		as-button=""
		class="card"
		data-oc-sheet-v1-create={JSON.stringify(comingSoonSheet(achievement.achievementId))}
		data-testid="achievement-coming-soon-card"
		id="achievement-card-{index+1}"
		on:click={() => onclick()}
	>
		<div
			class="oc-p-100 card__content"
			class:card__content--horizontal={isHorizontal}
			data-testid="achievement-coming-soon-card-content">
			<div class="card__body">
				<AchievementProgress icon="lock-closed" ariaLabel="Schloss Icon als Status, dass die Challenge bald verfügbar ist"/>
				<AchievementBody
					description={achievement.content.card.description}
					title={achievement.content.card.title}>
					<div class="oc-copy-75 text-secondary oc-pb-25">
						<span class="headline oc-px-50 oc-py-25">
							Vom {startDate}. - {endDate}.
						</span>
					</div>
				</AchievementBody>

			</div>
			<AchievementFooter
				compensationAmount={achievement.content.card.compensationAmount}
				compensationHeadline={'Verdiene'}
				isHorizontal={isHorizontal}>
				<oc-button-v1
					data-testid="achievement-coming-soon-card-button"
					oc-aria-label="Challenge bald verfügbar"
					icon-type-right="arrow-right"
					variant="secondary"
					size="50"
				>
					Bald verfügbar
				</oc-button-v1>
			</AchievementFooter>
		</div>
	</oc-card-v2>
</AchievementBaseCard>


<style lang="scss">
  @use '@otto-ec/otto-components-utils/scss/mixins' as mixins;

  .card {
    &__content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      &--horizontal {
        @include mixins.breakpoint(mixins.$breakpoint-l) {
          flex-direction: row;
        }
      }
    }

    &__body {
      display: flex;
      align-items: center;
    }
  }
  .headline {
    background-color: #78B4FF;
		font-weight: bold;
    border-radius: 2px;

  }
</style>
